<template>
	<view class="box">
		<view class="box_goods">
			<view class="box_goods_label">退款商品</view>
			<view class="box_goods_info">
				<view class="box_goods_info_img">
					<image src="@/static/uni.png" mode="widthFix"></image>
				</view>
				<view class="box_goods_info_right">
					<view class="box_goods_info_right_a">
						<view class="title">清澄白河马克杯-节日版</view>
						<view class="price">
							<text>¥</text>
							<text>79</text>
							<text>.98</text>
						</view>
					</view>
					<view class="box_goods_info_right_b">
						<text>白色</text>
						<text>x1</text>
					</view>
				</view>
			</view>
		</view>
		<view class="box_info">
			<view class="label">退款信息</view>
			<view class="list">
				<view class="list_item" @click="openOrder">
					<view class="list_item_label">
						<text>退款原因</text>
						<text>*</text>
					</view>
					<view class="list_item_to">
						<text>请选择</text>
						<uni-icons type="forward" size="18" color="#999999"></uni-icons>
					</view>
				</view>
				<view class="list_price">
					<view class="list_price_box">
						<view class="list_price_box_label">
							<text>退款原因</text>
							<text>*</text>
						</view>
						<view class="list_price_box_qian">
							<view class="list_price_box_qian_wz">
								<text>¥</text>
								<text>74</text>
								<text>.98</text>
							</view>
							<image src="@/static/icon/ic_edit@2x.png" mode="widthFix"></image>
						</view>
					</view>
					<view class="list_price_bottom">
						可修改，最多¥74.98，优惠券抵扣¥5
					</view>
				</view>
			</view>
		</view>
		<view class="box_fs">
			<view class="box_fs_left">
				<text>退货方式</text>
				<text>运费自付/垫付，手动填写单号</text>
			</view>
			<text class="box_fs_right">自行寄回</text>
		</view>
		<view class="box_desc">
			<view class="box_desc_label">补充描述和凭证</view>
			<view class="box_desc_ipt">
				<textarea placeholder="补充描述，有助于商家更好的处理售后问题"></textarea>
				<view class="box_desc_ipt_list">
					<view class="box_desc_ipt_list_item">
						<image src="@/static/icon/ic_pingzheng@2x.png" mode="widthFix"></image>
					</view>
				</view>
			</view>
		</view>
		<view class="box_zw"></view>
		<view class="box_footer">
			<view class="box_footer_btn">提交</view>
		</view>
		<!-- 退款原因 -->
		<uni-popup ref="popup1" background-color="#fff">
			<view class="popup1">
				<view class="popup_head">
					<text></text>
					<text>退款原因</text>
					<uni-icons type="closeempty" @click="close" size="20" color="#999999"></uni-icons>
				</view>
				<view class="popup_list">
					<view class="popup_list_item" v-for="(item, index) in cates" :key="index" @click="changeCate(index)">
						<text>{{item.name}}</text>
						<radio color="#D20A0A" :value="item.id" :checked="index === current" />
					</view>
				</view>
				<view class="popup_footer">
					<view class="popup_footer_btn">确定</view>
				</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				current: 0,
				cates: [
					{ name: '退运费', id: 1 },
					{ name: '大小/尺寸与商品描述不符', id: 2 },
					{ name: '材质与商品描述不符', id: 3 },
					{ name: '做工粗糙/有瑕疵', id: 4 }
				]
			}
		},
		methods: {
			openOrder() {
				this.$refs.popup1.open('bottom')
			},
			close() {
				this.$refs.popup1.close()
			},
			changeCate(index) {
				this.current = index
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_goods {
			width: 100%;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.box_goods_label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 32rpx;
			}
			.box_goods_info {
				display: flex;
				align-items: center;
				.box_goods_info_img {
					flex-shrink: 0;
					width: 180rpx;
					height: 180rpx;
					background: #FFFFFF;
					border-radius: 12rpx;
					border: 2rpx solid #F5F5F5;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 20rpx;
					image {
						width: 160rpx;
						height: 160rpx;
					}
				}
				.box_goods_info_right {
					flex: 1;
					height: 180rpx;
					display: flex;
					flex-direction: column;
					.box_goods_info_right_a {
						display: flex;
						align-items: center;
						justify-content: space-between;
						.title {
							width: 320rpx;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						.price {
							display: flex;
							align-items: center;
							text {
								&:nth-child(1) {
									font-size: 20rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-top: 6rpx;
								}
								&:nth-child(2) {
									font-size: 28rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
								}
								&:nth-child(3) {
									font-size: 20rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-top: 6rpx;
								}
							}
						}
					}
					.box_goods_info_right_b {
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 16rpx;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
				}
			}
		}
		.box_info {
			width: 100%;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			.label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.list {
				display: flex;
				flex-direction: column;
				width: 100%;
				.list_item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 44rpx;
					.list_item_label {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 32rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #333333;
							}
							&:nth-child(2) {
								font-size: 32rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #D20A0A;
							}
						}
					}
					.list_item_to {
						display: flex;
						align-items: center;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
							margin-right: 12rpx;
						}
					}
				}
				.list_price {
					margin-top: 52rpx;
					display: flex;
					flex-direction: column;
					.list_price_box {
						display: flex;
						align-items: center;
						justify-content: space-between;
						.list_price_box_label {
							text {
								&:nth-child(1) {
									font-size: 32rpx;
									font-family: PingFang SC-Medium, PingFang SC;
									font-weight: 500;
									color: #333333;
								}
								&:nth-child(2) {
									font-size: 32rpx;
									font-family: PingFang SC-Medium, PingFang SC;
									font-weight: 500;
									color: #D20A0A;
								}
							}
						}
						.list_price_box_qian {
							display: flex;
							align-items: center;
							.list_price_box_qian_wz {
								display: flex;
								align-items: center;
								text {
									&:nth-child(1) {
										font-size: 28rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #D20A0A;
										margin-top: 11rpx;
									}
									&:nth-child(2) {
										font-size: 40rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #D20A0A;
									}
									&:nth-child(3) {
										font-size: 28rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #D20A0A;
										margin-top: 11rpx;
									}
								}
							}
							image {
								width: 26rpx;
								height: 26rpx;
								margin-left: 12rpx;
							}
						}
					}
					.list_price_bottom {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
						margin-top: 20rpx;
					}
				}
			}
		}
		.box_desc {
			width: 100%;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			.box_desc_label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 36rpx;
			}
			.box_desc_ipt {
				width: 100%;
				padding: 28rpx 24rpx;
				background-color: #F5F5F5;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				textarea {
					width: 100%;
					height: 80rpx;
				}
				.box_desc_ipt_list {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					margin-top: 50rpx;
					.box_desc_ipt_list_item {
						width: 172rpx;
						height: 172rpx;
						image {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
		.box_zw {
			width: 100%;
			height: calc(112rpx + env(safe-area-inset-bottom));
		}
		.box_footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			box-sizing: border-box;
			background-color: #FFFFFF;
			padding: 20rpx 56rpx calc(20rpx + env(safe-area-inset-bottom)) 56rpx;
			.box_footer_btn {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
		}
		.popup1 {
			padding: 48rpx 32rpx 0 32rpx;
			.popup_head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
			}
			.popup_list {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 68rpx;
				.popup_list_item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 62rpx;
					&:last-child {
						margin-bottom: 0 !important;
					}
					text {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
				}
			}
			.popup_footer {
				padding: 0 24rpx 20rpx 24rpx;
				margin-top: 112rpx;
				.popup_footer_btn {
					width: 100%;
					height: 72rpx;
					line-height: 72rpx;
					text-align: center;
					background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
					border-radius: 36rpx;
					font-size: 32rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
				}
			}
		}
		.box_fs {
			width: 100%;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.box_fs_left {
				display: flex;
				flex-direction: column;
				text {
					&:nth-child(1) {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					&:nth-child(2) {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
						margin-top: 20rpx;
					}
				}
			}
			.box_fs_right {
				font-size: 28rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
		}
	}
</style>